<template>
    <section>
        <b-table striped :data="my_thesis" paginated per-page=10 :pagination-simple=false
            pagination-position="bottom" aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
            aria-current-label="Página actual">

            <b-table-column label="Código Carrera" field="career_code" width="100" sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Buscar Código..."
                        icon="search"
                        type="number"/>
                </template>
                <template v-slot="props">
                    {{ props.row.career_code }}
                </template>
            </b-table-column>

            <b-table-column label="Nombre de la Carrera" field="career_name" sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Buscar Nombre..."
                        icon="search"/>
                </template>
                <template v-slot="props">
                    {{ props.row.career_name }}
                </template>
            </b-table-column>

            <b-table-column label="Título del Trabajo" field="thesis_title" sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Buscar Título..."
                        icon="search"/>
                </template>
                <template v-slot="props">
                    {{ props.row.thesis_title }}
                </template>
            </b-table-column>

            <b-table-column label="Tipo de Participación" field="participation_type" sortable searchable>
                <template #searchable="props">
                    <b-input
                        v-model="props.filters[props.column.field]"
                        placeholder="Buscar Tipo..."
                        icon="search"/>
                </template>
                <template v-slot="props">
                    {{ props.row.participation_type }}
                </template>
            </b-table-column>
        </b-table>

        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios'
export default {
    props:[
        'personId',
    ],
    data() {
        return {
            isLoading:false,
            my_thesis: []
        }
    },
    created() {
        this.getMyThesis()
    },
    methods: {

        async getMyThesis() {
            this.isLoading = true
            await axios
                .get('/people/my-usach-thesis.json',{ params: {
                    id: this.personId
                }})
                .then(response => {
                    this.my_thesis = response.data
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        iconPack: 'fa',
                        icon: 'times-circle',
                        confirmText: 'Ok',
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>